import breakpoints from "./breakpoints";
import mediaQueries from "./mediaQueries";
import colors from "./colors";
import { lighten, darken } from "../utilities/color";

export const theme = {
  breakpoints,
  mediaQueries,
  space: [0, 4, 8, 10, 15, 20, 24, 30, 33, 35, 40, 50, 60, 70, 80, 85, 90, 100],
  fontSizes: [10, 12, 14, 15, 16, 18, 20, 22, 24, 36, 48, 80, 96],
  fontWeights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  lineHeights: {
    solid: 1,
    title: 1.25,
    copy: 1.5,
  },
  colors,
  colorStyles: {
    primary: {
      color: colors.primary.color,
      border: "1px solid",
      borderColor: colors.primary.borderColor,
      backgroundColor: colors.transparent,
      "&:hover": {
        color: colors.white,
        borderColor: colors.primary.borderColor,
        backgroundColor: colors.primary.hoverColor,
      },
      "&:focus": {
        color: colors.white,
        borderColor: colors.primary.borderColor,
        backgroundColor: colors.primary.hoverColor,
        boxShadow: `0 0 0 0.2rem ${lighten(colors.primary.color, 0.4)}`,
      },
      "&.focus": {
        color: colors.white,
        borderColor: colors.primary.borderColor,
        backgroundColor: colors.primary.hoverColor,
        boxShadow: `0 0 0 0.2rem ${lighten(colors.primary.color, 0.4)}`,
      },
      "&:not(:disabled):not(.disabled):active": {
        color: colors.white,
        borderColor: colors.primary.borderColor,
        backgroundColor: colors.primary.backgroundColor,
      }
    },
    secondary: {
      color: colors.secondary.color,
      border: "1px solid",
      borderColor: colors.secondary.borderColor,
      backgroundColor: colors.transparent,
      "&:hover": {
        color: colors.secondary.color,
        borderColor: colors.secondary.borderColor,
        backgroundColor: colors.secondary.hoverColor,
      },
      "&:focus": {
        color: colors.secondary.color,
        borderColor: colors.secondary.borderColor,
        backgroundColor: colors.secondary.hoverColor,
        boxShadow: `0 0 0 0.2rem ${lighten(colors.secondary.color, 0.4)}`,
      },
      "&.focus": {
        color: colors.secondary.color,
        borderColor: colors.secondary.borderColor,
        backgroundColor: colors.secondary.hoverColor,
        boxShadow: `0 0 0 0.2rem ${lighten(colors.secondary.color, 0.4)}`,
      },
      "&:not(:disabled):not(.disabled):active": {
        color: colors.secondary.color,
        borderColor: colors.secondary.borderColor,
        backgroundColor: colors.secondary.backgroundColor,
      }
    },
    info: {
      color: colors.info.color,
      border: "1px solid",
      borderColor: colors.info.borderColor,
      backgroundColor: colors.transparent,
      "&:hover": {
        color: colors.info.hoverColor,
        borderColor: colors.info.borderColor,
        backgroundColor: colors.info.color,
      },
    },
    success: {
      color: colors.success.color,
      border: "1px solid",
      borderColor: colors.success.borderColor,
      backgroundColor: colors.transparent,
      "&:hover": {
        color: colors.white,
        borderColor: colors.success.borderColor,
        backgroundColor: colors.success.color,
      },
    },
    warning: {
      color: colors.warning.color,
      border: "1px solid",
      borderColor: colors.warning.borderColor,
      backgroundColor: colors.transparent,
      "&:hover": {
        color: colors.black,
        borderColor: colors.warning.borderColor,
        backgroundColor: colors.warning.color,
      },
    },
    danger: {
      color: colors.danger.color,
      border: "1px solid",
      borderColor: colors.danger.borderColor,
      backgroundColor: colors.transparent,
      "&:hover": {
        color: colors.white,
        borderColor: colors.danger.borderColor,
        backgroundColor: colors.danger.color,
      },
    },
    primaryWithBg: {
      color: colors.white,
      border: "1px solid",
      borderColor: colors.primary.color,
      backgroundColor: colors.primary.color,
      "&:hover": {
        color: colors.white,
        borderColor: colors.primary.hoverColor,
        backgroundColor: colors.primary.hoverColor,
      },
      "&:focus": {
        color: colors.white,
        borderColor: colors.primary.hoverColor,
        backgroundColor: colors.primary.hoverColor,
        boxShadow: `0 0 0 0.2rem ${lighten(colors.primary.color, 0.4)}`,
      },
      "&.focus": {
        color: colors.white,
        borderColor: colors.primary.hoverColor,
        backgroundColor: colors.primary.hoverColor,
        boxShadow: `0 0 0 0.2rem ${lighten(colors.primary.color, 0.4)}`,
      },
      "&:not(:disabled):not(.disabled):active": {
        color: colors.white,
        borderColor: colors.primary.borderColor,
        backgroundColor: colors.primary.backgroundColor,
      }
    },
    secondaryWithBg: {
      color: colors.secondary.color,
      border: "1px solid",
      borderColor: colors.secondary.backgroundColor,
      backgroundColor: colors.secondary.backgroundColor,
      "&:hover": {
        color: colors.black,
        borderColor: colors.secondary.hoverColor,
        backgroundColor: colors.secondary.hoverColor,
      },
      "&:focus": {
        color: colors.black,
        borderColor: colors.secondary.hoverColor,
        backgroundColor: colors.secondary.hoverColor,
        boxShadow: `0 0 0 0.2rem ${lighten(colors.secondary.color, 0.4)}`,
      },
      "&.focus": {
        color: colors.black,
        borderColor: colors.secondary.hoverColor,
        backgroundColor: colors.secondary.hoverColor,
        boxShadow: `0 0 0 0.2rem ${lighten(colors.secondary.color, 0.4)}`,
      },
    },
    infoWithBg: {
      color: colors.info.color,
      border: "1px solid",
      borderColor: colors.info.backgroundColor,
      backgroundColor: colors.info.backgroundColor,
      "&:hover": {
        color: colors.info.hoverColor,
        borderColor: colors.info.color,
        backgroundColor: colors.info.color,
      },
    },
    successWithBg: {
      color: colors.success.color,
      border: "1px solid",
      borderColor: colors.success.backgroundColor,
      backgroundColor: colors.success.backgroundColor,
      "&:hover": {
        color: colors.white,
        borderColor: colors.success.color,
        backgroundColor: colors.success.color,
      },
    },
    warningWithBg: {
      color: colors.warning.color,
      border: "1px solid",
      borderColor: colors.warning.backgroundColor,
      backgroundColor: colors.warning.backgroundColor,
      "&:hover": {
        color: colors.black,
        borderColor: colors.warning.color,
        backgroundColor: colors.warning.color,
      },
    },
    dangerWithBg: {
      color: colors.white,
      border: "1px solid",
      borderColor: colors.danger.color,
      backgroundColor: colors.danger.color,
      "&:hover": {
        color: colors.white,
        borderColor: darken(colors.danger.color, 0.1),
        backgroundColor: darken(colors.danger.color, 0.1),
      },
    },
  },
  buttonStyles: {
    pill: {
      borderRadius: "600px",
    },
    square: {
      borderRadius: 0,
    },
  },
  buttonSizes: {
    sm: {
      paddingTop: "4px",
      paddingBottom: "4px",
      paddingRight: "8px",
      paddingLeft: "8px",
      fontSize: "12.25px",
      lineHeight: 1.5,
      borderRadius: "3.2px",
    },
    md: {
      paddingTop: "6px",
      paddingBottom: "6px",
      paddingRight: "12px",
      paddingLeft: "12px",
      fontSize: "14px",
      lineHeight: 1.5,
      borderRadius: "4px",
    },
    lg: {
      paddingTop: "8px",
      paddingBottom: "8px",
      paddingRight: "16px",
      paddingLeft: "16px",
      fontSize: "17.5px",
      lineHeight: 1.5,
      borderRadius: "4.8px",
    },
  },
  badgeColors: {
    primary: {
      color: colors.primary.color,
      border: "1px solid",
      borderColor: colors.primary.borderColor,
      backgroundColor: colors.transparent,
    },
    secondary: {
      color: colors.secondary.color,
      border: "1px solid",
      borderColor: colors.secondary.borderColor,
      backgroundColor: colors.transparent,
    },
    info: {
      color: colors.info.color,
      border: "1px solid",
      borderColor: colors.info.borderColor,
      backgroundColor: colors.transparent,
    },
    success: {
      color: colors.success.color,
      border: "1px solid",
      borderColor: colors.success.borderColor,
      backgroundColor: colors.transparent,
    },
    warning: {
      color: colors.warning.color,
      border: "1px solid",
      borderColor: colors.warning.borderColor,
      backgroundColor: colors.transparent,
    },
    danger: {
      color: colors.danger.color,
      border: "1px solid",
      borderColor: colors.danger.borderColor,
      backgroundColor: colors.transparent,
    },
    primaryWithBg: {
      color: colors.white,
      backgroundColor: colors.primary.color,
    },
    secondaryWithBg: {
      color: colors.secondary.color,
      backgroundColor: colors.secondary.backgroundColor,
    },
    infoWithBg: {
      color: colors.info.color,
      backgroundColor: colors.info.backgroundColor,
    },
    successWithBg: {
      color: colors.white,
      backgroundColor: colors.success.color,
    },
    warningWithBg: {
      color: colors.black,
      backgroundColor: colors.warning.color,
    },
    dangerWithBg: {
      color: colors.white,
      backgroundColor: colors.danger.color,
    },
  },
  badgeStyles: {
    pill: {
      paddingRight: "6.3px",
      paddingLeft: "6.3px",
      borderRadius: "160px",
    },
  },
  alertStyles: {
    info: {
      color: colors.info.color,
      backgroundColor: colors.info.backgroundColor,
      "& > div:first-child": {
        color: colors.info.backgroundColor,
        borderColor: colors.info.color,
        backgroundColor: colors.info.color,
      },
    },
    success: {
      color: colors.success.color,
      backgroundColor: colors.success.backgroundColor,
      "& > div:first-child": {
        color: colors.success.backgroundColor,
        borderColor: colors.success.color,
        backgroundColor: colors.success.color,
      },
    },
    warning: {
      color: colors.warning.color,
      backgroundColor: colors.warning.backgroundColor,
      "& > div:first-child": {
        color: colors.warning.backgroundColor,
        borderColor: colors.warning.color,
        backgroundColor: colors.warning.color,
      },
    },
    danger: {
      color: colors.danger.color,
      backgroundColor: colors.danger.backgroundColor,
      "& > div:first-child": {
        color: colors.danger.backgroundColor,
        borderColor: colors.danger.color,
        backgroundColor: colors.danger.color,
      },
    },
  },
  progressBarStyles: {
    info: {
      backgroundColor: colors.info.backgroundColor,
    },
    success: {
      backgroundColor: colors.success.backgroundColor,
    },
    warning: {
      backgroundColor: colors.warning.backgroundColor,
    },
    danger: {
      backgroundColor: colors.danger.backgroundColor,
    },
  },
  modalSizes: {
    sm: {
      [mediaQueries.smallUp]: {
        maxWidth: "300px",
      },
    },
    lg: {
      [mediaQueries.largeUp]: {
        maxWidth: "800px",
      },
    },
    xl: {
      [mediaQueries.largeUp]: {
        maxWidth: "800px",
      },
      [mediaQueries.xLargeUp]: {
        maxWidth: "1140px",
      },
    }
  },
  panelStyles: {
    bordered: {
      border: "1px solid",
      borderColor: colors.secondary.borderColor,
      overflow: "hidden",
    },
    shadowed: {
      boxShadow: "0 8px 16px rgba(0, 0, 21, 0.15)",
    },
    borderedShadowed: {
      border: "1px solid",
      borderColor: colors.secondary.borderColor,
      overflow: "hidden",
      boxShadow: "0 8px 16px rgba(0, 0, 21, 0.15)",
    },
  },
};
